/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { makeStyles } from '@material-ui/core/styles';
import ResponsiveImage from '../../../GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import transformRenderer from '../../../../../helpers/markdown/characterTransformer';
import LinkOrATag from '../../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const useStyles = makeStyles((theme) => ({
    container: {
        maxWidth: '1144px',
        width: '100%',
        position: 'relative',
        backgroundSize: 'cover',
        clipPath: 'url(#bottom)',
        background: theme.palette.cms?.gray || '#EEF3F6',
        margin: '0 auto',
    },
    heading: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        height: '175px',
        position: 'relative',
        '& h3': {
            zIndex: '999',
            background: theme.palette.cms?.gray || '#EEF3F6',
            padding: '25px 15px 18px',
            fontSize: '36px',
            margin: '34px 0px 0px',
        },
        [theme.breakpoints.down(599)]: {
            height: 'auto',
            '& h3': {
                padding: '25px 15px 0',
                zIndex: 'auto',
                margin: '0px',
            },
        },
    },

    cardContainer: {
        display: 'flex',
        width: '85%',
        margin: '0 auto',
        justifyContent: 'space-between',
        paddingBottom: '5em',
        [theme.breakpoints.down(599)]: {
            flexDirection: 'column',
            padding: ' 20px 0px 5em',
            width: '100%',
        },
    },
    cards: {
        flex: '1 1',
        padding: '0 10px',
        zIndex: '999',
        [theme.breakpoints.down(599)]: {
            width: '100%',
            zIndex: 'auto',
            margin: '10px 0px',
        },
    },
    cardImage: {
        border: `9px solid ${theme.palette.cms?.white || '#ffffff'}`,
        [theme.breakpoints.down(599)]: {
            border: `5px solid ${theme.palette.cms?.white || '#ffffff'}`,
        },

    },
    image: {
        width: '100%',
        maxheight: '298px',
        display: 'flex',
    },
    border: {
        height: '254px',
        border: `1px solid ${theme.palette.cms?.imageBorder || '#ACC6D6'}`,
        width: '78%',
        position: 'absolute',
        top: '85px',
        [theme.breakpoints.down(599)]: {
            top: '74px',
            height: '32px',
            width: '1px',
        },
    },
    cardTitle: {
        '& p': {
            fontSize: '32px',
            lineHeight: '38px',
            margin: ' 24px 0 0',
            [theme.breakpoints.down(599)]: {
                fontSize: '24px',
                lineHeight: '25px',
                margin: ' 10px 0px 0px',
            },
        },
    },
    cardContent: {
        '& p': {
            fontSize: '13px',
            lineHeight: '24px',
            margin: '10px 0',
            [theme.breakpoints.down(599)]: {
                lineHeight: '15px',
            },
        },
    },
    link: {
        fontSize: '13px',
        textDecoration: 'none',
        color: theme.palette.cms?.white || '#000000',
    },
    svgTear: {
        position: 'absolute',
        width: 0,
        height: 0,
    },
}));

const   MarketingSpotsPdPV2 = ({
    blockMatch,
}) => {
    const classes = useStyles();

    const cards = (cardData) => (
        <>
            <svg className={classes.svgTear}>
                <clipPath id="bottom" clipPathUnits="objectBoundingBox">
                    <path d="M0.004,0 C0.015,0.01,0.042,0.009,0.075,-0.015 C0.111,0.024,0.017,0.027,0.152,0.025 C0.2,0.053,0.182,0.014,0.257,0.021 C0.307,-0.006,0.343,0.037,0.343,0.023 C0.388,0.018,0.368,0.006,0.432,0.003 C0.51,-0.004,0.521,0.021,0.583,0.022 C0.632,0.022,0.599,0.016,0.692,0.011 C0.76,-0.015,0.779,0.029,0.833,0.02 C0.863,0.015,0.872,0.002,0.907,0 C0.946,-0.003,0.979,0.011,1,0.022 L1,0.976 C0.985,0.979,0.977,0.979,0.896,0.971 C0.862,0.96,0.857,0.95,0.835,0.946 C0.725,0.939,0.672,0.971,0.714,0.977 C0.632,0.983,0.631,0.941,0.579,0.951 C0.547,0.957,0.551,0.97,0.52,0.974 C0.463,0.982,0.442,0.941,0.385,0.945 C0.325,0.955,0.275,0.977,0.287,0.978 C0.263,0.98,0.197,0.976,0.191,0.955 C0.136,0.955,0.119,0.957,0.078,0.978 C0.045,0.97,0.033,0.942,0.017,0.951 C0.005,0.954,0.001,0.971,0,0.985" />
                </clipPath>
            </svg>
            <div className={classes.cardContainer}>
                {
                    cardData?.card.map((card) => (
                        <div
                            className={`${classes.cards}`}
                        >
                            <div className={`${classes.cardImage}`}>
                                <ResponsiveImage
                                    className={`${classes.image}`}
                                    path={card?.face_image?.url}
                                    alt={card?.face_image?.title}
                                    params={{}}
                                />
                            </div>
                            <div className={`${classes.cardDiscription}`}>
                                <div className={classes.cardTitle}>
                                    <ReactMarkdown
                                        renderers={transformRenderer}
                                        source={card?.face_title}
                                        escapeHtml={false}
                                    />
                                </div>
                                <div className={classes.cardContent}>
                                    <ReactMarkdown
                                        renderers={transformRenderer}
                                        source={card.card_copy}
                                        escapeHtml={false}
                                    />
                                </div>
                                {card?.link?.href
                                    ? (
                                        <LinkOrATag
                                            className={classes.link}
                                            href={card?.link?.href}
                                        >{card?.link?.title} &gt;
                                        </LinkOrATag>
                                    ) : null}
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    );

    const getStyles = (headerData) => {
        const style = {};
        if (headerData.heading_font?.length) style.fontFamily = headerData.heading_font?.split(':')[1].replace(';', '');
        return style;
    };

    const heading = (headerData) => (
        <div className={`${classes.heading}`} style={getStyles(headerData)}>
            <h3>{headerData.heading_copy}</h3>
            <div className={classes.border} />
        </div>
    );

    return (
        <div className={classes.container}>
            { blockMatch.map((block) => {
                const blockKey = Object.keys(block);
                const blockObj = block[blockKey];
                switch (blockKey[0]) {
                    case 'heading': return heading(blockObj);
                    case 'cards':  return cards(blockObj);
                    default: return null;
                }
            })}
        </div>
    );
};

MarketingSpotsPdPV2.propTypes = {
    blockMatch: arrayOf(
        shape({
            heading: shape({
                heading_copy: string,
            }),
            cards: arrayOf(
                shape({
                    face_title: string,
                    card_copy: string,
                    face_image: shape({
                        url: string,
                        tittle: string,
                    }),
                    link: shape({
                        href: string,
                        title: string,
                    }),
                }),
            ),
        }),
    ),
};
MarketingSpotsPdPV2.defaultProps = {
    blockMatch: {},
};

export default  MarketingSpotsPdPV2;
